import { c as _c } from "react/compiler-runtime";
//#region [Props]
type ExpandArrowSvgProps = {
  className?: string;
};
//#endregion

//#region [Component]
export default function ExpandArrowSvg(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><radialGradient id="ExpandArrowSvgGradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stopColor="var(--palette-melrose2)" /><stop offset="0.265" stopColor="var(--palette-french-pass)" /><stop offset="0.567" stopColor="var(--palette-your-pink)" /><stop offset="0.764" stopColor="var(--palette-illusion)" /><stop offset="1" stopColor="var(--palette-melrose2)" /></radialGradient></defs>;
    t2 = <path d="M-10456,15524a13,13,0,0,1,13-13,13,13,0,0,1,13,13,13,13,0,0,1-13,13A13,13,0,0,1-10456,15524Zm5.226-7.778A10.928,10.928,0,0,0-10454,15524a10.919,10.919,0,0,0,3.225,7.775A10.919,10.919,0,0,0-10443,15535a10.928,10.928,0,0,0,7.778-3.225A10.911,10.911,0,0,0-10432,15524a10.92,10.92,0,0,0-3.221-7.778A10.92,10.92,0,0,0-10443,15513,10.911,10.911,0,0,0-10450.776,15516.223Zm7.034,12.243-5.026-5.022a.967.967,0,0,1,0-1.368.97.97,0,0,1,1.373,0l4.336,4.336,4.336-4.336a.964.964,0,0,1,1.368,0,.963.963,0,0,1,0,1.372l-5.019,5.022a1.073,1.073,0,0,1-.132.109.962.962,0,0,1-.553.174A.963.963,0,0,1-10443.742,15528.466Z" transform="translate(10456.002 -15511.001)" fill="url(#ExpandArrowSvgGradient)" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg width="26.001" height="26.001" viewBox="0 0 26.001 26.001" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
//#endregion